// extracted by mini-css-extract-plugin
export var fixed = "spinner-module--fixed--36c8f";
export var ring = "spinner-module--ring--0d2fd";
export var segment = "spinner-module--segment--f97f5";
export var spinanimation = "spinner-module--spinanimation--39a21";
export var spinner = "spinner-module--spinner--d449a";